<template>
  <div v-show="isShow">
    <div><img @click="returnPage()" class="return-btn" src="../../assets/return-page.png" height="36" width="20"/></div>
    <div class="title">高校申请试用</div>
    <div>
      <van-form @submit="onSubmit">
        <van-field
          v-model="quaryParam.schoolname"
          required
          label="机构名称"
          placeholder="请输入机构名称"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          v-model="quaryParam.contacts"
          required
          label="联系人"
          placeholder="请输入联系人"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          v-model="quaryParam.phone"
          required
          label="手机号"
          placeholder="请输入手机号"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          v-model="quaryParam.message"
          required
          rows="2"
          autosize
          maxlength="200"
          label="申请说明"
          type="textarea"
          placeholder="请输入申请说明"
          :rules="[{ required: true, message: '' }]"
        />
        <van-button round block type="info" native-type="submit">提交</van-button>
      </van-form>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Toast } from 'vant';

Vue.use(Toast);
export default {
  name: "applyDetails",
  data(){
    return{
      isShow:false,
      quaryParam:{},
    }
  },
  methods:{
    init(){
      this.isShow = true
    },
    onSubmit() {
      this.axios({
        url: 'https://www.gocheck.cn/newsAction/getNews.do',//请求地址
        method:'post',//请求方法
        responseType: 'json',//返回值类型
        async: false,
        params: this.quaryParam
      }).then(res => {
        console.log(res)//请求成功
        Toast.success('提交成功！');
        this.isShow = false
        this.$emit('returnPage')
      }).catch(error => {
        console.log(error);//请求失败
      })
    },
    returnPage(){
      this.isShow = false
      this.$emit('returnPage')
    },
  }
}
</script>

<style scoped>
.title{
    position: fixed;
    height: 64px;
    background: #005CE5;
    margin: auto;
    left: 0;
    top: 0;
    right: 0;
    color: #FFFFFF;
    font-size: 18px;
    line-height: 65px;
}
.sub-btn{
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    width: 150px;
    height: 40px;
    margin-top: 30px;
    background: #005CE5;
    border-radius: 20px;
    color: #FFFFFF;
    font-size: 18px;
    font-weight: bold;
    line-height: 40px;
}
.return-btn{
    position: absolute;
    z-index: 9999;
    margin: auto;
    top: 22px;
    left: 12px;
    width: 10px;
    height: 18px;
}

</style>